module.exports = __webpack_public_path__ + "img/Orders opvolgen.5f40dec0.svg";